import deepMerge from './general/deepMerge';

// ----------------------------------------------------------------------------

type TypeMergeConfig = Record<string, any>;

// ----------------------------------------------------------------------------

function isObjectConfig(value: unknown): value is TypeMergeConfig {
    return value != null && typeof value === 'object' && !Array.isArray(value);
}

function getMergeValue(config: unknown): string | undefined {
    if (isObjectConfig(config) && typeof config.merge === 'string') {
        return config.merge;
    }

    if (typeof config === 'string') {
        return config;
    }

    return undefined;
}

function resolveInheritedConfig(config: unknown): unknown {
    if (!isObjectConfig(config) || typeof config.merge === 'undefined') {
        return config;
    }

    const nextConfig = { ...config };
    const mergeConfig = nextConfig.merge;

    delete nextConfig.merge;

    return deepMerge({}, nextConfig, mergeConfig);
}

// ----------------------------------------------------------------------------

function merge<TDefault extends TypeMergeConfig, TConfig = undefined>(
    defConfig: TDefault,
    config?: TConfig,
): TConfig extends TypeMergeConfig ? TConfig : TDefault {
    if (!config) {
        return defConfig as TConfig extends TypeMergeConfig ? TConfig : TDefault;
    }

    deepMerge(defConfig, resolveInheritedConfig(config));

    return defConfig as TConfig extends TypeMergeConfig ? TConfig : TDefault;
}

// ----------------------------------------------------------------------------

export { getMergeValue, merge };
